import { Link } from "react-router-dom";
import RatingsTally from "./RatingsTally";

const LOGO_URL = "https://static.readdy.ai/image/f9f32838a9120faa908a5852ba765d83/f8910ea58b264f83bfa3194cce1f37cf.png";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Episodes", to: "/episodes" },
  { label: "Contact", to: "/contact" },
];

const PLATFORMS = [
  { icon: "ri-spotify-fill", href: "#", label: "Spotify" },
  { icon: "ri-apple-fill", href: "#", label: "Apple Podcasts" },
];

export default function Footer() {
  return (
    <>
      <RatingsTally />
      <footer style={{ background: "linear-gradient(160deg, #431407 0%, #78350f 60%, #92400e 100%)" }} className="text-amber-100 pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">

          {/* Main 3-column grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-amber-700/40">

            {/* Left — Brand */}
            <div className="flex flex-col gap-5">
              <img
                src={LOGO_URL}
                alt="The Humble Machine"
                className="h-14 w-auto object-contain object-left brightness-0 invert opacity-90"
              />
              <div>
                <p className="font-serif italic text-amber-300 text-lg leading-relaxed">
                  &ldquo;The future belongs to the informed.&rdquo;
                </p>
              </div>
              <p className="font-sans text-sm text-amber-200/60 leading-relaxed max-w-xs">
                A podcast about Artificial Intelligence and humanity — honest, grounded, and built for everyday people.
              </p>
            </div>

            {/* Center — Navigation */}
            <div className="flex flex-col items-start md:items-center gap-5">
              <h4 className="font-sans uppercase text-xs tracking-widest text-amber-400 font-semibold">
                <a href="#navigate">Navigate</a>
              </h4>
              <nav className="flex flex-col items-start md:items-center gap-3">
                {NAV_LINKS.map((link) => (
                  <Link
                    key={link.label}
                    to={link.to}
                    className="font-sans text-sm text-amber-200/80 hover:text-amber-300 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
            </div>

            {/* Right — Listen & Subscribe */}
            <div className="flex flex-col gap-5">
              <h4 className="font-sans uppercase text-xs tracking-widest text-amber-400 font-semibold">
                <a href="#listen">Listen &amp; Subscribe</a>
              </h4>
              <p className="font-sans text-sm text-amber-200/60 leading-relaxed max-w-xs">
                Never miss an episode. Subscribe on your platform of choice.
              </p>

              {/* Platform icon buttons */}
              <div className="flex items-center gap-3">
                {PLATFORMS.map((p) => (
                  <a
                    key={p.label}
                    href={p.href}
                    rel="nofollow"
                    aria-label={p.label}
                    className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-amber-800/60 hover:bg-amber-700/80 border border-amber-600/30 hover:border-amber-500/50 transition-all duration-200 cursor-pointer"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${p.icon} text-amber-200 text-base`} />
                    </div>
                    <span className="font-sans text-xs font-medium text-amber-200 whitespace-nowrap">{p.label}</span>
                  </a>
                ))}
              </div>

              {/* Subscribe CTA */}
              <a
                href="#subscribe"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-amber-500 hover:bg-amber-400 transition-colors duration-200 cursor-pointer whitespace-nowrap w-fit"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-notification-3-line text-amber-900 text-sm" />
                </div>
                <span className="font-sans text-sm font-semibold text-amber-900">Subscribe &amp; Get Notified</span>
              </a>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="flex flex-col md:flex-row items-center justify-between pt-8 gap-4">
            <p className="font-sans text-xs text-amber-300/50">
              &copy; 2025 The Humble Machine. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              {["Privacy Policy", "Terms of Use"].map((l) => (
                <a
                  key={l}
                  href="#"
                  rel="nofollow"
                  className="font-sans text-xs text-amber-300/50 hover:text-amber-300 transition-colors cursor-pointer"
                >
                  {l}
                </a>
              ))}
            </div>
          </div>

        </div>
      </footer>
    </>
  );
}
